import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AccessibilityPanel } from '../../../components/accessibility';

const AccessibilitySettingsPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="relative">
      <AccessibilityPanel isOpen={true} onClose={() => navigate('/dashboard/settings')} />
    </div>
  );
};

export default AccessibilitySettingsPage;
